import React, { useEffect } from 'react';

const StripeBuyButton: React.FC = () => {
  useEffect(() => {
    // Dynamically load the Stripe Buy Button script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/buy-button.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup script on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="col-span-2 rounded-lg shadow-lg flex flex-col items-center cursor-pointer hover:shadow-xl transition-shadow duration-300 bg-white">
      {/*// @ts-ignore*/}
      <stripe-buy-button
        buy-button-id="buy_btn_1QdLF9LvCZQ8555PPX7CTwxQ"
        publishable-key="pk_live_51QX4LALvCZQ8555PKaSjavOgPsGjWLXTPy7jGHo57Kx1aga7qBwxhQIORNHJa0p05nwj7gumoXLlkf6rS1fQaEer00tBkpoolK"
      >
        {/*// @ts-ignore*/}
      </stripe-buy-button>
    </div>
  );
};

export default StripeBuyButton;
